// @ts-expect-error - @rails/actioncable doesn't have TypeScript declarations
import * as ActionCable from "@rails/actioncable"

export type ActionCableSubscriptionCallbacks = {
  connected?: () => void
  disconnected?: () => void
  received?: (data: unknown) => void
  rejected?: () => void
}

export type ActionCableSubscription = {
  unsubscribe: () => void
}

export type ActionCableConsumer = {
  subscriptions: {
    create: (params: Record<string, unknown>, callbacks?: ActionCableSubscriptionCallbacks) => ActionCableSubscription
  }
  disconnect?: () => void
}

let sharedConsumer: ActionCableConsumer | null = null
let activeUsers = 0

export const getActionCableConsumer = (): ActionCableConsumer => {
  if (!sharedConsumer) {
    sharedConsumer = ActionCable.createConsumer() as ActionCableConsumer
  }

  activeUsers += 1
  return sharedConsumer
}

export const releaseActionCableConsumer = () => {
  if (!sharedConsumer) return

  activeUsers = Math.max(activeUsers - 1, 0)
  if (activeUsers > 0) return

  if (typeof sharedConsumer.disconnect === "function") {
    sharedConsumer.disconnect()
  }

  sharedConsumer = null
}

export const resetActionCableConsumer = () => {
  if (sharedConsumer && typeof sharedConsumer.disconnect === "function") {
    sharedConsumer.disconnect()
  }

  sharedConsumer = null
  activeUsers = 0
}
